import envVar from '../config/envVars';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';
import httpPut from './httpClient/httpPut';

interface reportFilters {
  selectedColumns: string[];
  name: string;
  enrollmentNo: string;
  grade: string;
  division: string;
}

const fetchStudentReportApi = async (
  filter: reportFilters,
  page: number,
  perPage: number
) => {
  return httpPost(
    `${envVar.REACT_APP_BASE_API_URL}/reports/student?page=${page}&perPage=${perPage}`,
    filter
  );
};

const fetchStudentDetailApi = async (data: { studentIds: string[] }) => {
  return httpPost(
    `${envVar.REACT_APP_BASE_API_URL}/users/students?siblingDetails=true`,
    data
  );
};

const fetchStudentLCRequest = async (studentId: string) => {
  return httpGet(
    `${envVar.REACT_APP_BASE_API_URL}/users/students/${studentId}/lc-details`
  );
};
const acceptRejectStudentLC = async (studentId: string, status: string) => {
  return httpPut(
    `${envVar.REACT_APP_BASE_API_URL}/users/students/${studentId}/lc-details`,
    {
      status: status
    }
  );
};

const uploadProfilePhoto = async (
  id: string,
  file: File,
  isGuardianProfile?: boolean
) => {
  const formData = new FormData();
  formData.append('file', file);

  const data = Object.fromEntries(formData.entries());
  let url = `${envVar.REACT_APP_BASE_API_URL}/users/${id}/profile/photo`;
  if (isGuardianProfile) {
    url += '?isGuardianProfile=true';
  }
  return httpPost(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const updateDetailApi = async (id: string, data: any) => {
  return httpPut(`${envVar.REACT_APP_BASE_API_URL}/users/${id}`, data);
};

const activateStudent = async (studentId: string) =>
  httpPut(
    `${envVar.REACT_APP_BASE_API_URL}/students/${studentId}/activate`,
    {}
  );
const deActivateStudent = async (studentId: string) =>
  httpPut(
    `${envVar.REACT_APP_BASE_API_URL}/students/${studentId}/de-activate`,
    {}
  );

const generateBonafide = async (studentId: string) =>
  httpPost(
    `${envVar.REACT_APP_BASE_API_URL}/users/students/${studentId}/bonafide/generate`,
    { studentId }
  );

interface generateLCProps {
  progress: string;
  dateOfLeaving: string;
  generalConduct: string;
  reasonOfLeaving: string;
  passedAndPromotedToClass: string;
  detainedInClass: string;
  remarks: string;
}

const generateLC = async (studentId: string, data: generateLCProps) =>
  httpPost(
    `${envVar.REACT_APP_BASE_API_URL}/users/students/${studentId}/lc/generate`,
    data
  );
const requestLC = async (studentId: string) =>
  httpPost(
    `${envVar.REACT_APP_BASE_API_URL}/users/students/${studentId}/lc/request`,
    {}
  );

const fetchPDFResponse = async (url: string) => httpGet(url);

const addParentDetail = async (studentId: string, payload: any) =>
  httpPost(
    `${envVar.REACT_APP_BASE_API_URL}/users/${studentId}/parent`,
    payload
  );

const studentProfile = {
  fetchStudentReportApi,
  fetchStudentDetailApi,
  fetchStudentLCRequest,
  uploadProfilePhoto,
  updateDetailApi,
  acceptRejectStudentLC,
  activateStudent,
  deActivateStudent,
  generateBonafide,
  requestLC,
  fetchPDFResponse,
  generateLC,
  addParentDetail
};

export default studentProfile;
